/**
 * PAGE CONTENT
 * Contenu principal avec carte blanche
 */

import { type ReactNode } from 'react';

interface PageContentProps {
  title: string;
  description: string;
  actions?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

export function PageContent({ title, description, actions, children, footer }: PageContentProps) {
  return (
    <div className="flex flex-col flex-grow w-full overflow-hidden">
      <div className="bg-white relative w-full h-full flex flex-col rounded-b-card">
        {/* Title + Actions - STICKY - Hauteur fixe h-[6.25rem] (100px) pour aligner avec le side panel */}
        <div className="flex items-end justify-between h-[6.25rem] px-page-padding py-6 bg-white z-10 shrink-0">
          <div className="flex flex-col gap-1 max-w-[45rem]">
            <p className="text-page-title text-zinc-900">{title}</p>
            <p className="text-sm leading-5 text-zinc-500">{description}</p>
          </div>

          {actions && <div className="flex items-center gap-1.5">{actions}</div>}
        </div>

        {/* Separator */}
        <div className="w-full h-px bg-zinc-200 shrink-0" />

        {/* Main Content - SCROLLABLE */}
        <div className="flex-grow overflow-y-auto">{children}</div>

        {/* Footer (Pagination, etc.) - STICKY */}
        {footer && (
          <>
            {/* Separator */}
            <div className="w-full h-px bg-zinc-200 shrink-0" />
            <div className="shrink-0 bg-white">{footer}</div>
          </>
        )}
      </div>
    </div>
  );
}
